import { useEffect, useState } from 'react';

import Loading, { LoadingBall } from '@ingka/loading';
import { translate } from '@repo/phrase';

import styles from './styles.module.scss';

export const LoadingPage = () => {
    // Create a timer that changes the text inside every 5 seconds
    // so that the user knows that the page is still loading
    // and it's not stuck
    const [text, setText] = useState(translate('page_loading'));
    useEffect(() => {
        let index = 0;
        const timer = setInterval(() => {
            if (index === 1) {
                setText(translate('page_loading_dot'));
            }
            if (index === 2) {
                setText(translate('page_loading_dot_dot'));
            }
            index++;
        }, 5000);
        return () => {
            clearInterval(timer);
        };
    }, []);

    return (
        <Loading data-testid="loading-ball" text={text} className={String(styles.loading)}>
            <LoadingBall color="primary" />
        </Loading>
    );
};
